export default (state = {}) => state.config || {};
